export function getPartyCompositionType(partyCompositionId: string) {
  const typesIds: Record<string, string> = {
    11: 'type_alone',
    12: 'type_withpartner',
    13: 'type_friends',
    14: 'type_family',
    15: 'type_singleparent',
    16: 'type_group',
  }
  const typeId = partyCompositionId in typesIds ? typesIds[partyCompositionId] : 'type_unknown'

  return typeId
}
